import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

export default function ResetPassword() {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const requestReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      toast.success("If that email exists, a reset link was generated (check server logs in dev).");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  const doReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#050505] grid-bg flex items-center justify-center p-6">
      <div className="w-full max-w-md fade-up">
        <p className="label-xs mb-3">// {token ? "set new password" : "recover access"}</p>
        <h1 className="font-head text-3xl font-black tracking-tighter uppercase mb-8">
          {token ? "Reset password" : "Forgot password"}
        </h1>
        <form onSubmit={token ? doReset : requestReset} className="space-y-4">
          {!token ? (
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@domain.com"
              data-testid="reset-email-input"
              className="w-full h-12 bg-transparent border border-white/10 px-4 text-sm mono placeholder:text-zinc-600 focus:outline-none focus:border-white transition-colors" />
          ) : (
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="new password"
              data-testid="reset-password-input"
              className="w-full h-12 bg-transparent border border-white/10 px-4 text-sm mono placeholder:text-zinc-600 focus:outline-none focus:border-white transition-colors" />
          )}
          <button type="submit" disabled={loading} data-testid="reset-submit-btn"
            className="w-full h-12 bg-white text-black font-head font-bold text-sm uppercase tracking-wider hover:bg-zinc-300 transition-colors disabled:opacity-50">
            {loading ? "..." : (token ? "Update password" : "Send reset link")}
          </button>
        </form>
        <button onClick={() => navigate("/")} className="label-xs mt-6 hover:text-white transition-colors">← back to sign in</button>
      </div>
    </div>
  );
}
